<template>
  <div :id="content.idHTML" :class="jel_getClassObject(content)">
    <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
    <div class="d-block">
      <Paragraphe
        :content="{
          richText: msgDetails,
          classeCSS: 'pb-1',
        }"
      />
      <button class="btn btn-primaire d-block mx-auto px-4 mt-2" @click="retour()">
        {{ content.libRetour }}
      </button>
    </div>
  </div>
</template>

<script>
import { isProductSource2eChance } from '@/helpers/ProductSourceHelpers';
import Paragraphe from '../base/Paragraphe.vue';
import { registerVendorListenerConsent } from '@/helpers/ConsentHelpers';

// Helpers
import { returnToHome } from '@/helpers/RouteHelpers';

export default {
  name: 'Auth0Error',
  components: { Paragraphe },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      msgCode: null,
      msgDetails: null,
      msgUrlRetour: null,
    };
  },
  mounted() {
    if (this.$route.query.msg) {
      this.traiterMsgErreur(this.b64DecodeUnicode(this.$route.query.msg));
    } else {
      this.msgDetails = this.content.txtMsgDefaut;
    }
  },
  methods: {
    b64DecodeUnicode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(
        atob(str)
          .split('')
          .map(function (c) {
            return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
          })
          .join('')
      );
    },
    traiterMsgErreur(msg) {
      /*
      URL DE TEST : ?msg=ewogICAgICAiY29kZSI6ICIxMjM0IiwKICAgICAgIm1lc3NhZ2UiOiAidHJhbnNsYXRlZCBtZXNzYWdlIiwKICAgICAgInJldHVybl9oZXJlIjogImh0dHA6Ly93d3cuZ29vZ2xlLmNhIgp9
      URL DE TEST AUTO EXCL : ?msg=eyJjb2RlIjogIk9CX0VSUl9DVVNUX0lOX1NFTEZfRVhDTCIsICJtZXNzYWdlIjogIlZvdXMgbmUgcG91dmV6IHBhcyBvdXZyaXIgZGUgc2Vzc2lvbi4gVm91cyDDqnRlcyBwcsOpc2VudGVtZW50IGVuIHDDqXJpb2RlIGQnYXV0b2V4Y2x1c2lvbi4iLCAicmV0dXJuX2hlcmUiOiAiaHR0cHM6Ly9wb3J0YWlsLmRldi0yNS5lc3BhY2VqZXV4Lm9yZy9mci9hY2N1ZWlsIn0%3D
      */
      const msgObj = JSON.parse(msg);
      this.msgCode = msgObj.code;
      this.msgDetails = msgObj.message;
      this.msgUrlRetour = msgObj.return_here;
      // On affiche le message texte de 2eChance si et seulement si on vient de 2eChance
      if (/(2echance|2chance|2e-chance)/i.test(this.msgUrlRetour) || isProductSource2eChance()) {
        this.msgDetails = `${this.msgDetails}${this.content.txt2eChance}`;
      }

      // Message d'erreur spécifique si msgCode débute par Failed to find cust id for uuid
      if (this.msgCode?.startsWith('Failed to find cust id for uuid')) {
        document.querySelector('h1.grandTitre')?.replaceChildren(this.content.titleFailedCustId);
        this.msgDetails = this.content.txtFailedCustId;
      }

      // Ajout cookie autoexclusion
      if (this.msgCode === 'OB_ERR_CUST_IN_SELF_EXCL') {
        // eslint-disable-next-line no-undef
        ejApi.ecrireCookie('autoexclusion', true, 365);
        // Ne pas envoyer de publicités si autoexclu
        registerVendorListenerConsent(
          process.env.VUE_APP_IAB_ID_ANALYTICS,
          function () {
            localStorage.setItem('adviable', false);
          },
          function () {
            localStorage.removeItem('adviable');
          }
        );
      }
      // Ajout cookie pausedejeu
      else if (this.msgCode === 'OB_ERR_CUST_IN_PAUSE') {
        // eslint-disable-next-line no-undef
        ejApi.ecrireCookie('pausedejeu', true, 365);
        // Ne pas envoyer de publicités si en pause de jeu
        registerVendorListenerConsent(
          process.env.VUE_APP_IAB_ID_ANALYTICS,
          function () {
            localStorage.setItem('adviable', false);
          },
          function () {
            localStorage.removeItem('adviable');
          }
        );
      }
    },
    retour() {
      if (!this.msgUrlRetour || typeof this.msgUrlRetour === 'undefined') {
        returnToHome();
      } else {
        window.location.href = this.msgUrlRetour;
      }
    },
  },
};
</script>
